import { IFiltrosItensLote } from "../interfaces/IFiltrosItensLote";
import { IOrdenacao } from "../interfaces/IOrdenacao";

export const FILTROS_ITENS_LOTE_VAZIOS: IFiltrosItensLote = {
  placa: [],
  prensa: null,
  statusAutorizacao: null,
  statusProducao: null,
  idEmpresa: null,
  idProcesso: [],
};

export const ORDENACAO_ITENS_LOTE_PADRAO: IOrdenacao = {
  campo: "dataSolicitacao",
  direcao: "ASC",
};
